



















































import store from "@/store";

import { Component, Prop, Vue } from "vue-property-decorator";
import { Getter, Mutation, State } from "vuex-class";
import Auth from "@aws-amplify/auth";

import { MaintenancejobsState } from "@/store/maintenancejobs/types";

@Component
export default class Navbar extends Vue {
  @State("maintenancejobs") public maintenancejobsState: MaintenancejobsState;
  @Getter("auth/signedIn") public signedIn: boolean;
  @Getter("auth/isSysAdmin") public isSysAdmin: boolean;
  @Getter("auth/isAdministrator") public isAdministrator: boolean;
  @Getter("auth/isCustomer") public isCustomer: boolean;
  @Getter("auth/isSupport") public isSupport: boolean;
  @Getter("auth/isBaseUser") public isBaseUser: boolean;
  @Getter("auth/isAdvanceUser") public isAdvanceUser: boolean;

  @Mutation("auth/setCognitoUser")
  public setCognitoUser: (user: any) => void;

  /**
   * @see https://aws-amplify.github.io/docs/js/authentication
   */
  public async signOut() {
    try {
      this.$router.push({ name: "home" });
      // Check if there are any unsaved changes before signing the user out.
      if (
        !store.getters["customers/hasUnsavedChanges"] &&
        !store.getters["maintenancejobs/hasUnsavedChanges"]
      ) {
        await Auth.signOut();
        this.setCognitoUser(null);
        this.$router.push({ name: "sign-in" });
      }
    } catch (err) {
      this.$onecentral.displayError(err);
    }
  }
}
